var React = require('react');

function IconCalendar (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Calendar"),React.createElement("g",{"fill":"currentColor","fillRule":"nonzero","key":1},[React.createElement("path",{"d":"M2.495 4A.495.495 0 0 0 2 4.496v15.008c0 .274.222.496.495.496h17.01a.495.495 0 0 0 .495-.496V4.496A.495.495 0 0 0 19.505 4H2.495zm.189-2h16.632C20.798 2 22 3.2 22 4.681V19.32A2.683 2.683 0 0 1 19.316 22H2.684A2.683 2.683 0 0 1 0 19.319V4.68A2.683 2.683 0 0 1 2.684 2z","key":0}),React.createElement("path",{"d":"M15 1.071C15 .48 15.448 0 16 0s1 .48 1 1.071V4.93C17 5.52 16.552 6 16 6s-1-.48-1-1.071V1.07zM5 1.071C5 .48 5.448 0 6 0s1 .48 1 1.071V4.93C7 5.52 6.552 6 6 6s-1-.48-1-1.071V1.07zM1.05 10C.47 10 0 9.552 0 9s.47-1 1.05-1h18.9c.58 0 1.05.448 1.05 1s-.47 1-1.05 1H1.05z","key":1})])]);
}

IconCalendar.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = IconCalendar;

IconCalendar.default = IconCalendar;
